const rulesPattern = {
    phone: /^1[3-9]\d{9}$/, // 手机号
    phoneAndTel: /^((0\d{2,3}-\d{7,8})|(1[3-9]\d{9}))$/, // 手机号和座机号
    card: /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, // 身份证
    email: /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]/, // 邮箱格式
    remainder1: /^[0-9]\d*(\.\d{1,1})?$/, // 大于0，且最多保留一位小数
    remainder2: /^[0-9]\d*(\.\d{1,2})?$/, // 大于0，且最多保留两位小数
    remainder3: /^[0-9]{1,7}(\.[0-9]{1,2})?$/, // 大于0，小于9999999.99且最多保留两位小数
    hundred: /^(\d{1,2}(\.\d{1,2})?|100(\.0{1,2})?)$/, // 0-100，且最多保留两位小数
    pInteger: /^[1-9]\d*$/, // 正整数
    pInteger1: /^[0-9]\d*$/, // 0或者正整数
    password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,20}$/, //密码
  }
  export default rulesPattern
  